import { FETCH_PRODUCT_STOCK_DATA_FAILURE, FETCH_PRODUCT_STOCK_DATA_REQUEST, FETCH_PRODUCT_STOCK_DATA_SUCCESS, FETCH_PRODUCT_STOCK_PIVOTE_VIEW_DATA_FAILURE, FETCH_PRODUCT_STOCK_PIVOTE_VIEW_DATA_REQUEST, FETCH_PRODUCT_STOCK_PIVOTE_VIEW_DATA_SUCCESS, SET_WAREHOUSE_STOCK_RADIO_BTN } from "./productStock.actionsType";



export const PRODUCT_STOCK = 'productStock'


let initialState = {
    loading: false,
    productStockData: [],
    productStockPivotViewData: [],
    radioBtn: 'stock'

};

export let productStockReducer = (state = initialState, action) => {
    let { type, payload, updatePayload } = action;

    switch (type) {
        case FETCH_PRODUCT_STOCK_DATA_REQUEST:
        case FETCH_PRODUCT_STOCK_PIVOTE_VIEW_DATA_REQUEST:
            return {
                ...state,
                loading: true,
            };

        case FETCH_PRODUCT_STOCK_DATA_SUCCESS:
            return {
                ...state,
                loading: false,
                productStockData: updatePayload,
            };
        case FETCH_PRODUCT_STOCK_PIVOTE_VIEW_DATA_SUCCESS:
            return {
                ...state,
                loading: false,
                productStockPivotViewData: updatePayload,
            };
        case FETCH_PRODUCT_STOCK_DATA_FAILURE:
        case FETCH_PRODUCT_STOCK_PIVOTE_VIEW_DATA_FAILURE:
            return {
                ...state,
                loading: false,
                errorMessage: updatePayload
            };
        case SET_WAREHOUSE_STOCK_RADIO_BTN:
            return {
                ...state,

                radioBtn: payload
            };
        default:
            return state;
    }
};